import { Box, BoxProps, HStack, Image } from '@chakra-ui/react'
import { colors } from '../theme/cssVariables'
import defaultAvatar from '../assets/defaultAvatar.jpg'
import LevelIcon from './LevelIcon'
import { useMemo } from 'react'

// 处理 Steam 头像 URL
export const processSteamAvatarUrl = (url: string) => {
  try {
    if (!url.includes('steamstatic.com')) {
      return url
    }
    const match = url.match(/(.+)(\.(?:jpg|jpeg|png|gif|webp))$/)
    if (!match) {
      return url
    }
    return `${match[1]}_full${match[2]}`
  } catch (error) {
    console.error('Error processing Steam avatar URL:', error)
    return url
  }
}

interface AvatarProps extends BoxProps {
  url?: string
  boxSize?: string | number | string[] | number[]
  vipSize?: string | number | string[] | number[]
  vipStyle?: React.CSSProperties
  isRelative?: boolean
  isShowLevel?: boolean
}

export default function Avatar({
  url = defaultAvatar,
  width = '44px',
  isRelative = false,
  isShowLevel = true,
  vipStyle,
  ...props
}: AvatarProps) {
  // TODO: add utils to handle different level's color

  const { _vh, _vw } = useMemo(() => {
    if (isShowLevel) {
      const _w = parseInt(String(width))
      return {
        _vw: _w * 0.9,
        _vh: (_w * 15) / 44,
      }
    }
    return {}
  }, [isShowLevel, width])

  // 处理头像 URL
  const processedUrl = useMemo(() => {
    return processSteamAvatarUrl(url)
  }, [url])

  return (
    <HStack spacing="6px" pos="relative" color={colors.colorB2} _hover={{ color: colors.colorB1 }}>
      <Box w={width} h={width} borderRadius={'full'} {...props}>
        <Image
          w={'100%'}
          h={'100%'}
          src={processedUrl}
          alt="avatar"
          borderRadius={'full'}
          objectFit={'cover'}
          loading={'eager'}
        />
      </Box>
    </HStack>
  )
}
